import { SelectEffect, all, fork, select, takeEvery } from 'redux-saga/effects';
import loginSagas from '../components/login/redux/sagas';
import investmentSagas from '../components/main/Investments/redux/sagas';
import referralSagas from '../components/main/Referral/redux/sagas';
import annoucementSagas from '../components/main/announcements/redux/sagas';
import constantsSagas from '../components/main/constants/redux/sagas';
import dealPaymentSagas from '../components/main/dealPayment/redux/sagas';
import dealSagas from '../components/main/deals/redux/sagas';
import teamManagementSagas from '../components/main/onboarding/components/TeamManagement/redux/sagas';

function* watchAndLog() {
    yield takeEvery('*', function* logger(action) {
        const state: SelectEffect = yield select();
        console.debug('action', action);
        console.debug('state after', state);
    });
}

export default function* root() {
    const allForks = [
        fork(loginSagas),
        fork(dealSagas),
        fork(investmentSagas),
        fork(dealPaymentSagas),
        fork(annoucementSagas),
        fork(referralSagas),
        fork(constantsSagas),
        fork(teamManagementSagas),
    ];
    if (process.env.NODE_ENV === 'development') {
        allForks.unshift(fork(watchAndLog));
    }
    yield all(allForks);
}
